var render = function render(){var _vm=this,_c=_vm._self._c;return _c('fragment',[_c('Base',{staticClass:"space",class:[_vm.data.space.hide_on_mobile ? 'mobile-hide' : '',
          _vm.data.space.hide_on_desktop ? 'desktop-hide' : ''],style:([_vm.styles])},[_c('div',{style:(_vm.customHeight),attrs:{"data-distance":_vm.data.space.distance,"data-negative":(_vm.data.space.negative ? 'true': '')}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }